<template>
  <ul class="sc-events-log__list" v-if="type === `type-1`">
    <sc-events-log-list-item-type-1
      v-for="event in eventsData"
      :key="event.id"
      :event="event"
    />
  </ul>
  <ul class="sc-events-log__list" v-else-if="type === `type-2`">
    <sc-events-log-list-item-type-2
      v-for="event in eventsData"
      :key="event.id"
      :event="event"
    />
  </ul>
</template>

<script>
import scEventsLogListItemType1 from "./events-log-list-item-type-1";
import scEventsLogListItemType2 from "./events-log-list-item-type-2";
import { getWidgetStyleConfig } from "../../../../configs";

export default {
  props: {
    eventsData: {
      type: Array,
      required: true,
      default: () => null
    },
    type: {
      type: String,
      default: "type-1"
    }
  },
  components: { scEventsLogListItemType1, scEventsLogListItemType2 },
  methods: {
    getIconName(id) {
      const layerStyle = getWidgetStyleConfig("events_log");

      return layerStyle.icons[id] || layerStyle.icons.default;
    },
    getColor(id) {
      const layerStyle = getWidgetStyleConfig("events_log");

      return layerStyle.colors[id] || layerStyle.colors.default;
    }
  }
};
</script>

<style lang="scss">
.sc-events-log__list {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  height: 220px;
  overflow: hidden;
  overflow-y: auto;
}
</style>
